// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2KpZ6l","btn-primary":"_3dESVI","btn-secondary":"_3AWRsL","btn-link":"_14Me7y"};